import { get, post } from "../../../../services/request";

export const getAllStateLicense = () => {
  return get("StateLicense/GetAllStateLicense");
};

export const getStateLicenseNotesByDetailsId = (payload) => {
  return get(`StateLicense/GetStateLicenseNotesByDetailsId/${payload.stateLicenseDetailsId}`);
};

export const getLicenseAndRadSiteAssignmentNotesByProviderId = (radiologistId) => {
  return get(`RadSiteAssignmentNotes/GetLicenseAndRadSiteAssignmentNotesByProviderID?radiologistID=${radiologistId}`);
};

export const addStateLicenseNote = (payload) => {
  return post("StateLicense/AddStateLicenseNote", payload);
};
